module.exports = __webpack_public_path__ + "img/mx_seguromovil.fe98d4fe.png";